import { render } from "./icon-add.vue?vue&type=template&id=40de620a"
import script from "./icon-add.vue?vue&type=script&lang=js"
export * from "./icon-add.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__